import { createGlobalStyle } from 'styled-components'

export const Globals = createGlobalStyle`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'geist', sans-serif;
  }

  ::selection {
    color: ${({ theme }) => theme.colour.secondary.base} !important; // override ant styles
    background-color: ${({ theme }) => theme.colour.primary._200} !important; // override ant styles
  }

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (max-width: 767px) {
    select,
    textarea,
    input {
      font-size: 16px !important;
    }
  }

  // need to globally apply these styles to essentially hide the default leaflet div icon
  .leaflet-div-icon {
    background: transparent;
    border: none;
  }
`
